const warned = {};

export function deprecatedPropType(propType, explanation = '') {
  return (props, propName, componentName, ...rest) => {
    if (props.hasOwnProperty(propName) && process.env.NODE_ENV !== 'production') {
      const messageArray = [];
      messageArray.push(`"${propName}" property of "${componentName}" is deprecated`);
      messageArray.push(', it may be deleted in the next major release');
      if (explanation) {
        messageArray.push('\n');
        messageArray.push(explanation);
      }

      const message = messageArray.join('');
      if (!warned[message]) {
        console.warn(message);
        warned[message] = true;
      }
    }

    return propType(props, propName, componentName, ...rest);
  };
}
